module.exports = __webpack_public_path__ + "img/IMG_7326.f32c0a71.jpg";